// Static resources for fallback when backend is unavailable
import enCommon from '../shared/lib/i18n/locales/en/common.json'
import enChat from '../shared/lib/i18n/locales/en/chat.json'
import enPages from '../shared/lib/i18n/locales/en/pages.json'
import enErrors from '../shared/lib/i18n/locales/en/errors.json'

import fiCommon from '../shared/lib/i18n/locales/fi/common.json'
import fiChat from '../shared/lib/i18n/locales/fi/chat.json'
import fiPages from '../shared/lib/i18n/locales/fi/pages.json'
import fiErrors from '../shared/lib/i18n/locales/fi/errors.json'

import svCommon from '../shared/lib/i18n/locales/sv/common.json'
import svChat from '../shared/lib/i18n/locales/sv/chat.json'
import svPages from '../shared/lib/i18n/locales/sv/pages.json'
import svErrors from '../shared/lib/i18n/locales/sv/errors.json'

import frCommon from '../shared/lib/i18n/locales/fr/common.json'
import frChat from '../shared/lib/i18n/locales/fr/chat.json'
import frPages from '../shared/lib/i18n/locales/fr/pages.json'
import frErrors from '../shared/lib/i18n/locales/fr/errors.json'

import deCommon from '../shared/lib/i18n/locales/de/common.json'
import deChat from '../shared/lib/i18n/locales/de/chat.json'
import dePages from '../shared/lib/i18n/locales/de/pages.json'
import deErrors from '../shared/lib/i18n/locales/de/errors.json'

export const resources = {
  en: {
    common: enCommon,
    chat: enChat,
    pages: enPages,
    errors: enErrors,
  },
  fi: {
    common: fiCommon,
    chat: fiChat,
    pages: fiPages,
    errors: fiErrors,
  },
  sv: {
    common: svCommon,
    chat: svChat,
    pages: svPages,
    errors: svErrors,
  },
  fr: {
    common: frCommon,
    chat: frChat,
    pages: frPages,
    errors: frErrors,
  },
  de: {
    common: deCommon,
    chat: deChat,
    pages: dePages,
    errors: deErrors,
  },
}

// Single source of truth for supported languages — derived from the bundled
// locale resources, so adding a new language to `resources` automatically
// propagates to i18next config, language pickers, and validation guards.
export type SupportedLanguage = keyof typeof resources

export const SUPPORTED_LANGUAGES = Object.keys(resources) as SupportedLanguage[]

export function isSupportedLanguage(value: string): value is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}

/**
 * Native display name (autonym) for a language code, e.g. 'fi' -> 'Suomi'.
 * Uses Intl.DisplayNames so new languages need no hardcoded name table.
 */
export function languageDisplayName(code: string): string {
  try {
    const name = new Intl.DisplayNames([code], { type: 'language' }).of(code)
    if (name) return name.charAt(0).toLocaleUpperCase(code) + name.slice(1)
  } catch {
    // Unknown code — fall through to returning the code itself
  }
  return code
}
